import inEU from '@segment/in-eu'

export const euChecker = () => {
  return inEU() ? true : false
}
